// ------ SKELETONS' COLORS ------
export const baseColorSkeletonDark = 'var(--color-backgroundSecondary)'
export const highlightColorSkeletonDark = 'var(--color-backgroundTertiary)'

export const baseColorSkeletonLight = 'var(--color-backgroundPrimary)'
export const highlightColorSkeletonLight = 'var(--color-backgroundSecondary)'

export { ALGOLIA_INDEXES } from '@algoacademy/backend/modules/docs/algolia-indexes'
